'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _graphqlRequest = require('graphql-request');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(requestConfig, apiContext) {
    var graphQLClient, headers, _get, query, variables, transform, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(0, _isEmpty2.default)(requestConfig.url)) {
              _context.next = 2;
              break;
            }

            throw new Error('api endpoint must be configured and defined.');

          case 2:
            graphQLClient = new _graphqlRequest.GraphQLClient(requestConfig.url);
            headers = (0, _defaultsDeep2.default)(requestConfig.headers, apiContext.headers);
            _get = (0, _get3.default)(requestConfig, 'params', {}), query = _get.query, variables = _get.variables, transform = _get.transform;
            // variables could be passed to the call from web client and injected into the query here

            _context.prev = 5;
            _context.next = 8;
            return graphQLClient.request(query, variables, headers);

          case 8:
            data = _context.sent;
            return _context.abrupt('return', transform ? transform(data) : data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](5);

            _context.t0.context = {
              isGraphQlError: true
            };
            throw _context.t0;

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[5, 12]]);
  }));

  function gqlRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  }

  return gqlRequest;
}();
//# sourceMappingURL=gqlRequest.js.map